var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vb-checkbox',{attrs:{"vb_options":{
    text: 'Mostra in base al credito',
    value: _vm.filter_availability,
    checked: _vm.filter_availability,
    type: 'light',
    switch: true,
  }},on:{"change":_vm.handle_change}})
}
var staticRenderFns = []

export { render, staticRenderFns }